import React from 'react';
import PropTypes from 'prop-types';
import _ from "underscore";

// NOSONAR: `category` and `label` are Blockly toolbox-XML pseudo-elements,
// not real DOM elements. Attributes like `iconclass` and `text` are valid
// Blockly toolbox attributes.
const Lists = ({ blocks, context }) => {
    const childBlocks = _.map(blocks, ({ component: BlockComponent }, blockKey) => (
        <BlockComponent context={context} key={blockKey} />
    ));

    if (childBlocks.length > 0) {
        return (
            <category name='Lists' id='lists' iconclass='category with-icon-paths snap-icon-list2_dual'>{/* NOSONAR */}
                <label text="Lists"></label>{/* NOSONAR */}
                { childBlocks }
            </category>
        );
    }

    return null;
};

Lists.propTypes = {
    blocks: PropTypes.object.isRequired,
    context: PropTypes.object.isRequired,
};

export default Lists;